// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","meal__dialogContent":"meal__dialogContent-iC_zW","baggagePage":"baggagePage-1pZP-"};